module.exports = __webpack_public_path__ + "551d42809663e00822980c3d54205b48.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/images/cross.png
// module id = iDK4
// module chunks = 0